import { IShopContentTokenConfigGroup, ShopTokenGroup, IShopContentTokensConfig, ShopTokenFieldType } from "./types.js";

export const shopContentTokenGroups: IShopContentTokenConfigGroup[] = [
    {
        name: "General",
        title: "General",
        group: ShopTokenGroup.General,
        description: "Common tokens used in the shop",
    },
    {
        name: "Labels",
        title: "Labels",
        group: ShopTokenGroup.Label,
        description: "Label tokens are used to display text labels",
    },
    {
        name: "Buttons",
        title: "Buttons",
        group: ShopTokenGroup.Button,
        description: "Button tokens are used to display buttons",
    },
    {
        name: "Errors",
        title: "Errors",
        group: ShopTokenGroup.Error,
        description: "Error tokens are used to display error messages",
    },
    {
        name: "Titles",
        title: "Titles",
        group: ShopTokenGroup.Title,
        description: "Title tokens are used to display titles",
    },
    {
        name: "Descriptions",
        title: "Descriptions",
        group: ShopTokenGroup.Description,
        description: "Description tokens are used to display descriptions",
    },
    {
        name: "Links",
        title: "Links",
        group: ShopTokenGroup.Link,
        description: "Link tokens are used to display links",
    },
    {
        name: "Navigation",
        title: "Navigation",
        group: ShopTokenGroup.Navigation,
        description: "Navigation tokens are used to display navigation links",
    },
    {
        name: "Help",
        title: "Help",
        group: ShopTokenGroup.Help,
        description: "Help tokens are used to display help messages",
    },
];


export const shopContentTokensConfig: IShopContentTokensConfig = {
    lang: "en",
    tokens: [
            
        {
            key: "asdfasdf",
            value: "adfp",
            group: ShopTokenGroup.Label,
            title: "Sign Up",
            description: "The name of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,
            params: {
                parameter1: "OPTIONAL",
                parameter2: "OPTIONAL"
            },
            meta: {
                type: "TEXT",
                value: "Shop Name",
            },
        },
        
        {
        key: "signUp",
        value: "Sign Up",
        group: ShopTokenGroup.Label,
        title: "Sign Up",
        description: "The name of the shop",
        fieldType: ShopTokenFieldType.SingleLineContent,
        params: {
            parameter1: "REQUIRED",
            parameter2: "REQUIRED"
        },
        meta: {
            type: "TEXT",
            value: "Shop Name",
        },
    },
    {
        key: "testToke2n",
        value: "Test Token 2",
        group: ShopTokenGroup.Label,
        title: "Test Tokee",
        description: "The name of the shop",
        fieldType: ShopTokenFieldType.Html,

        meta: {
            type: "TEXT",
            value: "Shop Name",
        },
    },
        {
            key: "testToken",
            value: "Test Token 2",
            group: ShopTokenGroup.Label,
            title: "Test Tokee",
            description: "The name of the shop",
            fieldType: ShopTokenFieldType.MultilineContent,
            minLength: 10,
            maxLength: 100,
            meta: {
                type: "TEXT",
                value: "Shop Name",
            },
        },
        {
            key: "shopTitle",
            value: "Shop Title",
            group: ShopTokenGroup.General,
            title: "Shop Title",
            description: "The Title of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,

            meta: {
                type: "TEXT",
                value: "Shop Title",
            },
        },
        {
            key: "shopName",
            value: "Shop Name",
            group: ShopTokenGroup.General,
            title: "Shop Name",
            description: "The name of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,

            meta: {
                type: "TEXT",
                value: "Shop Name",
            },
        },
        {
            key: "shopDescription",
            value: "Shop Description",
            group: ShopTokenGroup.Description,
            title: "Shop Description",
            description: "The description of the shop",
            fieldType: ShopTokenFieldType.MultilineContent,
   
            meta: {
                type: "TEXT",
                value: "Shop Description",
            },
        },
        {
            key: "shopLogo",
            value: "Shop Logo",
            group: ShopTokenGroup.General,
            title: "Shop Logo",
            description: "The logo of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,

            meta: {
                type: "TEXT",
                value: "Shop Logo",
            },
        },
        {
            key: "shopBanner",
            value: "Shop Banner",
            group: ShopTokenGroup.Label,
            title: "Shop Banner",
            description: "The banner of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,
            params: {
                shopBanner: "REQUIRED",
            },
            meta: {
                type: "TEXT",
                value: "Shop Banner",
            },
        },
        {
            key: "shopContactEmail",
            value: "Shop Contact Email",
            group: ShopTokenGroup.Label,
            title: "Shop Contact Email",
            description: "The contact email of the shop",
            fieldType: ShopTokenFieldType.SingleLineContent,
            params: {
                shopContactEmail: "REQUIRED",
            },
            meta: {
                type: "TEXT",
                value: "Shop Contact Email",
            },
        }],
};